import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxTabComponent } from './rx-tab/rx-tab.component';
import { RxTabsComponent } from './rx-tabs/rx-tabs.component';
import { RxRoleGuardModule } from '@nrwl/rx-directives';

@NgModule({
  imports: [CommonModule, RxButtonModule, RxRoleGuardModule, RxTabComponent, RxTabsComponent],
  exports: [RxTabComponent, RxTabsComponent],
})
export class RxTabsModule {}
